// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 966 ? "login" : chunkId) + "-legacy." + {"552":"fccf8f60","565":"0178bbeb","640":"82d6ea94","736":"fbd69396","858":"5630f48d","966":"1342c350"}[chunkId] + ".js";
};